
import { Grid, Box, Typography } from "@mui/material";
import React from "react";
import AdjustIcon from "@mui/icons-material/Adjust";
import { useNavigate } from "react-router-dom";
import { useConvertPrice } from "../../../Hooks/useConvertPrice";
import defaultImage from "../../../Common/productDefaultImage.png";

const OrderCart = ({ item }) => {
  const navigate = useNavigate();
  const { convert, selectedCurrency } = useConvertPrice();

  return (
    <Box
      key={item.id}
      onClick={() => navigate(`/account/order/${item.id}`)}
      className="p-4 mb-5  hover:shadow-lg cursor-pointer transition duration-300 bg-white"
    >
      {item?.orderItems?.map((orderItem, index) => (
        <>
          <Grid
            container
            spacing={2}
            key={orderItem.id}
            alignItems="center"
            className="flex-wrap"
          >
            {/* Image + Product Info */}
            <Grid item xs={12} sm={8} className="flex items-center">
              {(() => {
                const primaryImage = orderItem?.product?.images?.find(img => img.isPrimary && img?.productColor?.color?.name === orderItem.variant?.productColor?.color?.name);
                return primaryImage ? (
                  <img
                    src={primaryImage.fullUrl || defaultImage}
                    alt="Product"
                    className="w-[6rem] h-[6rem] object-cover object-top rounded-md"
                  />
                ) : (
                  <img
                    src={defaultImage}
                    alt="No_image"
                    className="w-[6rem] h-[6rem] object-cover object-top rounded-md"
                  />
                );
              })()}

              <Box className="ml-4 space-y-1 flex-1 min-w-0">
                <Typography
                  className="text-base font-semibold"
                  sx={{
                    wordBreak: 'break-word',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    lineHeight: 1.3
                  }}
                >
                  {orderItem?.product?.title}
                </Typography>
                {/* <Typography className="text-sm text-gray-500">
                  Size: {orderItem?.size} | Color: {orderItem?.color}
                </Typography>
                <Typography className="text-sm text-gray-500">
                  Brand: {orderItem?.product?.brand?.name}
                </Typography> */}
                <Typography className="text-lg font-semibold text-gray-700">
                  {convert(orderItem?.orderPrice)} {selectedCurrency}
                  {/* ₹{orderItem?.orderPrice} */}
                </Typography>
              </Box>
            </Grid>

            {/* Delivery Status */}
            <Grid item xs={12} sm={4}>
              {item?.orderStatus === "DELIVERED" ? (
                <Box className="text-green-700">
                  <Box className="flex items-center mb-1">
                    <AdjustIcon sx={{ fontSize: 16 }} className="mr-2 flex-shrink-0" />
                    <Typography
                      className="text-sm font-medium"
                      sx={{
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical'
                      }}
                    >
                      Delivered on {item?.deliveryDate}
                    </Typography>
                  </Box>
                  <Typography className="text-xs">Your item has been delivered</Typography>
                </Box>
              ) : item?.orderStatus === "CANCELLED" ? (
                <Box className="text-red-600">
                  <Box className="flex items-center">
                    <AdjustIcon sx={{ fontSize: 16 }} className="mr-2 flex-shrink-0" />
                    <Typography className="text-sm font-medium">Cancelled Order</Typography>
                  </Box>
                </Box>
              ) : item?.orderStatus === "SHIPPED" ? (
                <Box className="text-yellow-600">
                  <Typography
                    className="text-sm font-medium"
                    sx={{
                      wordBreak: 'break-word',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    Estimated Delivery: {item?.deliveryDate}
                  </Typography>
                  <Typography className="text-sm text-gray-800 mt-1">
                    Your Order Items has been Shipped.
                  </Typography>
                </Box>
              ) : item?.orderStatus === "PLACED" ? (
                <Box className="text-yellow-600">
                  <Typography
                    className="text-sm font-medium"
                    sx={{
                      wordBreak: 'break-word',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    Estimated Delivery: {item?.deliveryDate}
                  </Typography>
                  <Typography className="text-sm text-gray-800 mt-1">
                    Your Order Items has been Accepted.
                  </Typography>
                </Box>
              ) : item?.orderStatus === "RETURNED" ? (
                <Box className="text-red-600">
                  <Box className="flex items-center">
                    <AdjustIcon sx={{ fontSize: 16 }} className="mr-2" />
                    <Typography className="text-sm font-medium">Return Request Created</Typography>
                  </Box>
                </Box>
              ) : item?.orderStatus === "PICKED_UP" ? (
                <Box className="text-green-600">
                  <Box className="flex items-center">
                    <AdjustIcon sx={{ fontSize: 16 }} className="mr-2" />
                    <Typography className="text-sm font-medium">Pickde Up Your Return Order</Typography>
                  </Box>
                </Box>
              ) : item?.orderStatus === "COMPLETED" ? (
                <Box className="text-green-600">
                  <Box className="flex items-center">
                    <AdjustIcon sx={{ fontSize: 16 }} className="mr-2" />
                    <Typography className="text-sm font-medium">Return Process Completed and Payment Transfer.</Typography>
                  </Box>
                </Box>
              ) : (
                <Box className="text-yellow-600">
                  <Typography
                    className="text-sm font-medium"
                    sx={{
                      wordBreak: 'break-word',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    Estimated Delivery: {item?.deliveryDate}
                  </Typography>
                  <Typography className="text-sm text-gray-800 mt-1">
                    Your Order Items has been Placed.
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
          {index < item?.orderItems?.length - 1 && <div className=" border border-bottom mb-4 mt-4" />}
        </>
      ))}
    </Box>
  );
};

export default OrderCart;
